// Updated ImagesContainer component
import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import ClassNames from "classnames";
import { swapProductImage } from "../../../api/index";
import Popup from "../Popup/index";

class ImagesContainer extends Component {
  state = {
    activePopupIndex: 0,
    popupOpened: false,
    images: this.props.images,
    defaultImageIndex: 0,
    isLoading: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.images !== this.props.images) {
      this.setState({ images: this.props.images });
    }
  }

  handleImagesChange = (index, e) => {
    const file = e.target.files && e.target.files[0];
    const url = e.target[0] && e.target[0].value;
    this.props.onImagesChange(file, url, index);
    this.setState({ popupOpened: false });
  };

  handleSetDefaultImage = (index) => {
    if (index === 0 || !this.props.enableImageSwap) return;
    this.setState({ isLoading: true });
    console.log('this.props.isTmp', this.props.isTmp)
    if (this.props.isTmp) {
      this.props.onSwap(index);
      const newImages = [...this.state.images];
      [newImages[0], newImages[index]] = [newImages[index], newImages[0]];
      this.setState({ images: newImages, defaultImageIndex: 0, isLoading: false });
    } else {
      swapProductImage(this.props.productId, `image${index + 1}`)
        .then((response) => {
          const updatedProduct = response.data;
          const newImages = [
            updatedProduct.default_image?.url || updatedProduct.url_default_image,
            updatedProduct.image2?.url || updatedProduct.url_image2,
            updatedProduct.image3?.url || updatedProduct.url_image3,
            updatedProduct.image4?.url || updatedProduct.url_image4,
            updatedProduct.image5?.url || updatedProduct.url_image5,
          ];
          this.setState({ images: newImages, defaultImageIndex: 0 });
        })
        .catch((error) => console.error("Failed to swap default image:", error))
        .finally(() => this.setState({ isLoading: false }));
    }
  };

  toggleRemoveBtn = (index, display) => {
    this.refs[`remove-button-${index}`].style.display = display;
  };

  togglePopup = (index, e) => {
    const { link, toEditPlan } = this.props;
    if (!link) {
      e.preventDefault();
      this.setState({
        activePopupIndex: index,
        popupOpened: !this.state.popupOpened,
      });
    } else {
      toEditPlan(true);
    }
  };

  getStyles(styles) {
    return ClassNames({
      "space-around": styles === "product",
      "space-between": styles === "room",
    });
  }

  renderPopupContent() {
    const index = this.state.activePopupIndex;
    const isLocalImage = this.state.images[index]?.substring(0, 4) === "blob";
    return (
      <div className="popup-content row justify-content-center">
        <input
          type="file"
          className="upload-file"
          id={`productImageFile`}
          name={`product.image`}
          onChange={this.handleImagesChange.bind(this, index)}
        />
        <label className="upload-file-label col-6 col-md-3 mb-5 mb-md-0" htmlFor={`productImageFile`}>
          Choose File
        </label>
        <form className="upload-form row justify-content-center" onSubmit={this.handleImagesChange.bind(this, index)}>
          <input type="text" className="upload-url col-8 col-md-6 mb-5 mb-md-0" id="uploadUrl" />
          <button type="submit" className="upload-url-label col-8 col-md-4 mb-5 mb-md-0" htmlFor={`uploadUrl`}>
            Upload by URL
          </button>
        </form>
        {!isLocalImage && this.state.images[index] && (
          <div className="popup-content__img-url-container row justify-content-center">
            <div className="col-6 col-lg-12">
              <a href={this.state.images[index]}>
                <span className="popup-content__img-url-text">{this.state.images[index]}</span>
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { images, defaultImageIndex, isLoading } = this.state;
    return (
      <div className="container-fluid mb-5 images-container position-relative">
        {isLoading && (
          <div className="preloader-overlay">
            <FontAwesomeIcon icon={faSpinner} spin size="2x" />
          </div>
        )}
        <div className={`${this.getStyles(this.props.customStyles)} row`}>
          {images.map((img, i) => (
            <div key={i} style={{textAlign: 'center'}}>
              <div className="d-flex align-items-center justify-content-center mb-2">
                {this.props.enableImageSwap && (
                  <span className="main-image-label mr-2">MAIN IMAGE</span>
                )}
                {i === defaultImageIndex && this.props.enableImageSwap && (
                  <FontAwesomeIcon icon={faCheck} className="text-success mr-2" />
                )}
                {i > 0 && i < 5 && this.props.enableImageSwap && (
                  <input
                    type="checkbox"
                    checked={i === defaultImageIndex}
                    onChange={() => this.handleSetDefaultImage(i)}
                    className=""
                    style={{width: '10%', marginBottom: 0}}
                    disabled={isLoading}
                  />
                )}
              </div>
              <div className={`images-wrapper-${this.props.imageSize}`}>
                {img ? (
                  <div
                    className="d-flex justify-content-center"
                    onMouseEnter={this.toggleRemoveBtn.bind(this, i, "block")}
                    onMouseLeave={this.toggleRemoveBtn.bind(this, i, "none")}
                  >
                    <img src={img} className="photo rounded" alt="..." />
                    {!this.props.link && (
                      <div
                        ref={`remove-button-${i}`}
                        className="remove-button"
                        onClick={this.handleImagesChange.bind(this, i)}
                      >
                        REMOVE
                      </div>
                    )}
                  </div>
                ) : (
                  <div className={`images-default-container-${this.props.imageSize}`} />
                )}
              </div>
              <div className="upload-button-wrapper">
                <button
                  className="upload-button"
                  onClick={this.togglePopup.bind(this, i)}
                  disabled={isLoading}
                >
                  <FontAwesomeIcon icon={faCamera} /> {!this.props.link ? "UPLOAD" : "CHANGE"}
                </button>
              </div>
            </div>
          ))}
          {!images.length && <div className="col-2">No images</div>}
        </div>
        {!this.props.link && (
          <Popup
            title="UPLOAD IMAGE"
            activePopupIndex={this.state.activePopupIndex}
            opened={this.state.popupOpened}
            onClose={this.togglePopup}
            renderContent={this.renderPopupContent.bind(this)}
          />
        )}
      </div>
    );
  }
}

ImagesContainer.propTypes = {
  images: PropTypes.array,
  onImagesChange: PropTypes.func,
  imageSize: PropTypes.oneOf(["small", "large"]),
  productId: PropTypes.number.isRequired,
  enableImageSwap: PropTypes.bool,
  isTmp: PropTypes.bool,
  onSwap: PropTypes.func,
};

ImagesContainer.defaultProps = {
  enableImageSwap: false,
  isTmp: false,
};

export default ImagesContainer;
